import React from "react";
import Brand from "./Brand";

export const CONTACT_EMAIL = "j.martin@gatai.de";

function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="section-shell footer-main">
        <div className="footer-brand">
          <Brand light />
          <p>Bußgeldmanagement für Autovermietungen: Bescheide scannen, Fahrer zuordnen, fristgerecht weiterleiten.</p>
          <address className="footer-address">
            <span>Martin Digital Solutions</span>
            <span>Inhaber: Julian Martin</span>
            <span>Cranachstr. 44</span>
            <span>D-12157 Berlin, Germany</span>
          </address>
        </div>
        <div className="footer-links">
          <strong>Produkt</strong>
          <a href="/#produkt">Funktionen</a>
          <a href="/#datenschutz">Datenschutz</a>
          <a href="/#integration">Integration</a>
        </div>
        <div className="footer-links">
          <strong>Kontakt</strong>
          <a href="/#kontakt">Jetzt testen</a>
          <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
          <a href="/vermietungen/login">Anmelden</a>
        </div>
        <div className="footer-links">
          <strong>Informationen</strong>
          <a href="/#faq">Häufige Fragen</a>
          <a href="/impressum">Impressum</a>
          <a href="/Datenschutz">Datenschutzerklärung</a>
          {/* The AVV is deliberately absent: it is a contract document for
              customers, reached from the Konfigurator, and it carries a
              noindex tag. Linking it here would put it back in front of
              everyone the AGB is meant to reach. */}
          <a href="/vermietungen/agb">AGB für Vermietungen</a>
        </div>
      </div>
      <div className="section-shell footer-bottom">
        <span>© {new Date().getFullYear()} Martin Digital Solutions (Inhaber: Julian Martin)</span>
        <span>Entwickelt mit Autovermietungen in Deutschland.</span>
      </div>
    </footer>
  );
}

export default SiteFooter;
